export const HEADER_ACCEPT: string = "application/json"
export const HEADER_CONTENT_TYPE: string = "application/json; charset=utf-8;"
export const CALLBACK_URL: string = `https://${window.location.host}/verify`

export const ROUTES: Readonly<Record<string, string>> = {
  ROOT: "/",
  LOGIN: "/login",
  AUTOLOGIN: "/autologin",
  VERIFY: "/verify",
  SIGN_UP_ACCOUNT_USER: "/sign-up/account",
  SIGN_UP_ACCOUNT_OWNER_ONE: "/sign-up/account/owner/step-1",
  SIGN_UP_ACCOUNT_OWNER_TWO: "/sign-up/account/owner/step-2",
  SIGN_UP_ACCOUNT_OWNER_VERIFY_EMAIL: "/sign-up/verify/email",
  CREATE_PASSWORD_OWNER: "/account/owner/password",
  WORKSPACES: "/workspace",
  WORKSPACE_WIZARD: "/workspace/:id/wizard",
  WORKSPACE_COMPLETE: "/workspace/:id/complete",
  WORKSPACE_ROLES: "/workspace/:id/roles",
  WORKSPACE_USERS: "/workspace/:id/users",
  USER_EDIT: "/workspace/:id/users/:user_id",
  BUSINESS: "/workspace/:id/business",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  NOT_FOUND: "*",
}
